import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import SmartFeedPagination from "%/dynamic-component-editor/options/smart-feed-pagination";

export default class SmartFeedSeeAllText extends BaseOption {
  static label = "See All Text";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
  };
  static defaultValue = "See All";

  static canShow(paginationType) {
    return paginationType === SmartFeedPagination.optionValues.linkToViewAllPage.id;
  }
}
